module.exports = __webpack_public_path__ + "1afa40e0beba83b9295d60b9f94317e7.MP3";